module.exports = __webpack_public_path__ + "img/action-Blocat.be695034.svg";